import { mdiChevronDown } from "@mdi/js";
import Icon from "@mdi/react";
import { listColumns } from "actions/columns/listColumns";
import { changeKeyword } from "actions/gantt";
import { searchTask, setVisibleHeader } from "actions/kanban/setting";
import { hideProject } from "actions/project/hideProject";
import { showProject } from "actions/project/showProject";
import { actionVisibleDrawerMessage } from "actions/system/system";
import { CustomLayoutContext } from "components/CustomLayout";
import { CustomTableContext } from "components/CustomTable";
import HeaderProject from "components/HeaderProject";
import TemplateHeader from "components/TemplateHeader";
import { apiService } from "constants/axiosInstance";
import { DRAWER_TYPE } from "constants/constants";
import { exportToCSV } from "helpers/utils/exportData";
import { find, flattenDeep, get, isNil, join, debounce } from "lodash";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  projectSelector,
  showHidePendingsSelector,
  tasksSelector,
} from "views/ProjectPage/RightPart/AllTaskTable/selectors";
import { viewPermissionsSelector } from "views/ProjectPage/selectors";
import {
  taskSearchSelector,
  visibleSelector,
} from "../KanbanPage/Header/selectors";
import { listTask } from "actions/task/listTask";
import {
  DEFAULT_MESSAGE,
  SNACKBAR_VARIANT,
  SnackbarEmitter,
} from "constants/snackbarController";
import { getPermissionViewDetailProject } from "actions/viewPermissions";
import LoadingBox from "components/LoadingBox";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const MiniContainer = ({ className = "", ...props }) => (
  <div
    className={`view_KanbanHeader___container-mini ${className}`}
    {...props}
  />
);

const LayoutDetail = ({
  children,
  tasks,
  project,
  viewPermissions,
  showHidePendings,
  handleExpand,
  doHideProject,
  doShowProject,
  projectInfo,
  keyword,
  taskSearchStr,
  doSearchTask,
  expand = false,
  doActionVisibleDrawerMessage,
  visible,
  doSetVisibleHeader,
  handleClose,
  handleOpen,
  doListTask,
}) => {
  const { doOpenModal, setItemLocation, setSearchText } =
    useContext(CustomLayoutContext);
  const dispatch = useDispatch();
  const location = useLocation();
  const isProject = location.pathname === "/projects";
  const TableContext = React.useContext(CustomTableContext);
  const parsedPath = location.pathname.split("/");
  const [view, setViewParam] = useState("");
  const [projectId, setProjectId] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [memberId, setMemberId] = useState("");
  const search = location.search;
  const params = new URLSearchParams(search);
  const groupID = params.get("groupID");
  const { templateId } = useParams();

  const isTemplate = useMemo(() => {
    return parsedPath.includes("template");
  }, [parsedPath]);
  const isProjectAddNew = useMemo(() => {
    return parsedPath.includes("add-new");
  }, [parsedPath]);
  const isPreview = useMemo(() => {
    return parsedPath.includes("preview");
  }, [parsedPath]);
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const checkDeny = async () => {
    if (projectId !== null) {
      try {
        let prjId = projectId?.split("?")?.[0] ?? "";
        if (!prjId || prjId === "") return;
        const res = await apiService({
          url: "/project/detail",
          method: "get",
          params: {
            project_id: prjId,
          },
        });
        if (res?.data?.state) {
          dispatch(getPermissionViewDetailProject({ projectId: prjId }));
          setLoading(false);
        } else {
          history.push("/projects/deny");
        }
      } catch (e) {
        history.push("/projects/deny");
      }
    }
  };

  React.useLayoutEffect(() => {
    if (projectId) {
      if (history.location.pathname !== "/projects") {
        checkDeny();
      }
    }
    // eslint-disable-next-line
  }, [projectId]);

  useEffect(() => {
    if (isTemplate) {
      setCategoryId(parsedPath[3]);
      setViewParam(parsedPath[6]);
      setProjectId(parsedPath[7]);
      setMemberId(parsedPath[8]);
    } else {
      setViewParam(parsedPath[2]);
      const prjId = parsedPath[3]?.split("?")?.[0] ?? "";
      setProjectId(prjId);
      setMemberId(parsedPath[4]);
    }
  }, [isTemplate, parsedPath]);

  useEffect(() => {
    if (isPreview) {
      handleClose();
    }
  }, [isPreview]);

  useEffect(() => {
    if (isProject && !isProjectAddNew) {
      handleOpen();
    }
  }, [isProject, isProjectAddNew]);

  const disableShowHide = !isNil(
    find(
      showHidePendings.pendings,
      (pending) => pending === get(project.project, "id")
    )
  );
  const query = useQuery();
  React.useEffect(() => {
    if (query.get("open-employee")) {
      doOpenModal("SETTING_MEMBER", {});
    }
  }, [query]);

  const reloadListTask = () => {
    doListTask({
      projectId,
      timeStart: undefined,
      timeEnd: undefined,
    });
  };

  const _handleAddNewColumns = (dataColumn) => {
    if (!dataColumn) return;
    /* Dispatching an action to the Redux store. */
    dispatch(listColumns({ project_id: projectId }));
  };

  const _handleHideColumn = async (idHide, statusUpdate = 0, index) => {
    await apiService({
      data: {
        project_field_id: idHide,
        project_id: projectId,
        status: statusUpdate,
      },
      url: "/project-field/set-status",
      method: "POST",
    });

    dispatch(listColumns({ project_id: projectId }));
  };

  const _handleReOrderColumns = async (colId, pos) => {
    try {
      const result = await apiService({
        data: {
          project_field_id: colId,
          project_id: projectId,
          sort_index: pos,
        },
        url: "/project-field/sort",
        method: "POST",
      });

      if (result?.data?.state) {
        setTimeout(() => {
          dispatch(listColumns({ project_id: projectId }));
        }, 300);
      }
    } catch (err) {
      SnackbarEmitter(
        SNACKBAR_VARIANT.ERROR,
        get(err, "message", DEFAULT_MESSAGE.MUTATE.ERROR)
      );
    }
  };

  const _handleChangeSummaryRowStatus = useCallback(
    async (check) => {
      try {
        const res = await apiService({
          data: {
            project_id: projectId,
            status: check,
          },
          url: "/project/set-summary-row-status",
          method: "POST",
        });

        if (res?.data?.state) {
          reloadListTask();
          return true;
        }
        return false;
      } catch (err) {
        SnackbarEmitter(
          SNACKBAR_VARIANT.ERROR,
          get(err, "message", DEFAULT_MESSAGE.MUTATE.ERROR)
        );
        return false;
      }
    },
    [projectId]
  );

  const _exportData = () => {
    const data = flattenDeep(
      tasks.tasks.map((groupTask) =>
        get(groupTask, "tasks", []).map((task) => ({
          id: get(task, "id", ""),
          groupTask: get(groupTask, "name", ""),
          name: get(task, "name", ""),
          status: get(task, "status_name", ""),
          duration:
            get(task, "duration_value", 0) +
            " " +
            get(task, "duration_unit", ""),
          start_time: get(task, "start_time", ""),
          start_date: get(task, "start_date", ""),
          end_time: get(task, "end_time", ""),
          end_date: get(task, "end_date", ""),
          progress: get(task, "complete", 0) + "%",
          priority: get(task, "priority_name", ""),
          members: join(
            get(task, "members", []).map((member) => get(member, "name")),
            ","
          ),
        }))
      )
    );

    exportToCSV(data, "tasks");
  };

  const handleOpenShareModal = () => {
    doOpenModal("SHARE_PROJECT", {});
  };

  const setView = () => {
    switch (view) {
      case "task-kanban":
        return {
          view: "kanban",
          project: project.project,
          valueSearch: taskSearchStr,
          onSearch: (searchStr) => doSearchTask(searchStr),
          onOpenCreateModal: (event) =>
            doOpenModal("MENU_CREATE", event?.target),
          canUpdateProject: get(
            viewPermissions.permissions,
            [projectId, "update_project"],
            false
          ),
          onUpdateMember: () => doOpenModal("MEMBER_SETTING", {}),
          onUpdateTime: () => doOpenModal("CALENDAR", {}),
          onShareProject: handleOpenShareModal,
          onUnShareProject: () => doOpenModal("UN_SHARE_PROJECT", {}),
          onUpdateVisible: () =>
            get(project, "project.visibility", false)
              ? doHideProject({ projectId: get(project?.project, "id") })
              : doShowProject({ projectId: get(project?.project, "id") }),
          onUpdateSetting: () => {
            doOpenModal("SETTING", {
              curProject: project.project,
              canChange: {
                date: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                copy: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                view: true,
              },
            });
          },
          onOpenFilterKanban: () =>
            doActionVisibleDrawerMessage({
              type: DRAWER_TYPE.KANBAN.FILTER,
              anchor: "right",
              options: {},
            }),
          expand: expand,
          onExpand: handleExpand,
        };
      case "task-gantt":
        return {
          view: "grantt",
          project: project.project,
          valueSearch: keyword,
          canUpdateProject: get(
            viewPermissions.permissions,
            [projectId, "update_project"],
            false
          ),
          onSearch: (searchStr) => doSearchTask(searchStr),
          onOpenCreateModal: (event) =>
            doOpenModal("MENU_CREATE", event?.target),
          onUpdateTime: () => console.log("CALENDAR"),
          onShareProject: handleOpenShareModal,
          onUnShareProject: () => doOpenModal("UN_SHARE_PROJECT", {}),
          onUpdateSetting: () =>
            doOpenModal("SETTING", {
              curProject: project.project,
              canChange: {
                date: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                copy: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                view: true,
              },
            }),
          expand: expand,
          onExpand: handleExpand,
          onUpdateVisible: () => {
            get(project, "project.visibility", false)
              ? doHideProject({ projectId: get(project?.project, "id") })
              : doShowProject({ projectId: get(project?.project, "id") });
          },
        };
      case "task-chat":
        return {
          view: "chat",
          project: project.project,
          valueSearch: keyword,
          onSearch: (searchStr) => doSearchTask(searchStr),
          onOpenCreateModal: (event) =>
            doOpenModal("MENU_CREATE", event?.target),
          onUpdateTime: () => console.log("CALENDAR"),
          onShareProject: handleOpenShareModal,
          onUnShareProject: () => doOpenModal("UN_SHARE_PROJECT", {}),
          canUpdateProject: get(
            viewPermissions.permissions,
            [projectId, "update_project"],
            false
          ),
          onUpdateSetting: () =>
            doOpenModal("SETTING", {
              curProject: project.project,
              canChange: {
                date: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                copy: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                view: true,
              },
            }),
          expand: expand,
          onExpand: handleExpand,
          onUpdateVisible: () => {
            get(project, "project.visibility", false)
              ? doHideProject({ projectId: get(project?.project, "id") })
              : doShowProject({ projectId: get(project?.project, "id") });
          },
        };
      case "dashboard":
        return {
          view: "dashboard",
          project: project.project,
          valueSearch: get(TableContext?.options, "search.patern", ""),
          onSearch: (value) =>
            get(TableContext?.options, "search.onChange", () => null)(value),
          onOpenCreateModal: (event) =>
            doOpenModal("MENU_CREATE", event?.target),
          hasMemberId: isNil(memberId),
          canUpdateProject:
            get(
              viewPermissions.permissions,
              [projectId, "update_project"],
              false
            ) && isNil(memberId),
          disableShowHide,
          onUpdateMember: () => doOpenModal("SETTING_MEMBER"),
          onUpdateTime: () => doOpenModal("CALENDAR", {}),
          onShareProject: handleOpenShareModal,
          onUnShareProject: () => doOpenModal("UN_SHARE_PROJECT", {}),
          onUpdateSetting: () =>
            doOpenModal("SETTING", {
              curProject: project.project,
              canChange: {
                date: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                copy: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                view: true,
              },
            }),
          expand: expand,
          onExpand: handleExpand,
          onUpdateVisible: () => {
            get(project, "project.visibility", false)
              ? doHideProject({ projectId: get(project?.project, "id") })
              : doShowProject({ projectId: get(project?.project, "id") });
          },
        };
      case "report":
        return {
          view: "report",
          project: project.project,
          valueSearch: get(TableContext?.options, "search.patern", ""),
          onSearch: (value) =>
            get(TableContext?.options, "search.onChange", () => null)(value),
          hasMemberId: isNil(memberId),
          canUpdateProject:
            get(
              viewPermissions.permissions,
              [projectId, "update_project"],
              false
            ) && isNil(memberId),
          disableShowHide,
          expand: expand,
          onExpand: handleExpand,
          onShareProject: handleOpenShareModal,
          onOpenCreateModal: (event) =>
            doOpenModal("MENU_CREATE", event?.target),
          onUpdateSetting: () =>
            doOpenModal("SETTING", {
              curProject: project.project,
              canChange: {
                date: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                copy: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                view: true,
              },
            }),
          onUpdateVisible: () => {
            get(project, "project.visibility", false)
              ? doHideProject({ projectId: get(project?.project, "id") })
              : doShowProject({ projectId: get(project?.project, "id") });
          },
        };
      default:
        return {
          view: "list",
          project: project.project,
          valueSearch: get(TableContext?.options, "search.patern", ""),
          onSearch: _handleSearch,
          onOpenCreateModal: (event) =>
            doOpenModal("MENU_CREATE", event?.target),
          onAddColumns: _handleAddNewColumns,
          onHideColumn: _handleHideColumn,
          setItemLocation: setItemLocation,
          hasMemberId: isNil(memberId),
          canUpdateProject:
            get(
              viewPermissions.permissions,
              [projectId, "update_project"],
              false
            ) && isNil(memberId),
          disableShowHide,
          onUpdateMember: () => doOpenModal("SETTING_MEMBER"),
          onUpdateTime: () => doOpenModal("CALENDAR", {}),
          onShareProject: handleOpenShareModal,
          onUnShareProject: () => doOpenModal("UN_SHARE_PROJECT", {}),

          onUpdateVisible: () => {
            get(project, "project.visibility", false)
              ? doHideProject({ projectId: get(project?.project, "id") })
              : doShowProject({ projectId: get(project?.project, "id") });
          },
          onUpdateSetting: () =>
            doOpenModal("SETTING", {
              curProject: project.project,
              canChange: {
                date: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                copy: get(
                  viewPermissions.permissions,
                  [projectId, "update_project"],
                  false
                ),
                view: true,
              },
            }),
          onExportData: () => _exportData,
          expand: expand,
          onExpand: handleExpand,
          onReOrderColumns: _handleReOrderColumns,
          onChangeSummaryRowStatus: _handleChangeSummaryRowStatus,
        };
    }
  };

  const deboundSearch = React.useCallback(
    debounce((value) => setSearchText(value), 700),
    []
  );

  const _handleSearch = (value) => {
    deboundSearch(value);
  };

  return (
    <>
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          {!isProject && view === "task-kanban" && (
            <>
              {visible ? (
                isTemplate ? (
                  <TemplateHeader
                    projectId={projectId}
                    categoryId={categoryId}
                    templateId={templateId}
                    {...setView()}
                  />
                ) : (
                  <HeaderProject {...setView()} />
                )
              ) : (
                <MiniContainer>
                  <Icon
                    path={mdiChevronDown}
                    size={1}
                    onClick={() => doSetVisibleHeader(true)}
                  />
                </MiniContainer>
              )}
            </>
          )}
          {!isProject &&
            view !== "task-kanban" &&
            (isTemplate ? (
              <TemplateHeader
                projectId={projectId}
                categoryId={categoryId}
                templateId={templateId}
                {...setView()}
              />
            ) : (
              <HeaderProject {...setView()} />
            ))}
          {isTemplate ||
          (!groupID &&
            !isProject &&
            view !== "task-chat" &&
            view !== "report") ? (
            <div
              className="template-preview-body"
              style={{
                height: isTemplate
                  ? "calc(100vh - 88px)"
                  : "calc(100vh - 72px)",
                ...(view === "dashboard" && {
                  background: "#F7F9FC",
                }),
              }}
            >
              {React.cloneElement(children, { aaaa: 1 })}
            </div>
          ) : (
            React.cloneElement(children, { aaaa: 1 })
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    tasks: tasksSelector(state),
    project: projectSelector(state),
    viewPermissions: viewPermissionsSelector(state),
    showHidePendings: showHidePendingsSelector(state),
    projectInfo: state.gantt.projectInfo,
    keyword: state.gantt.keyword,
    taskSearchStr: taskSearchSelector(state),
    visible: visibleSelector(state),
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    doHideProject: ({ projectId }) => dispatch(hideProject({ projectId })),
    doShowProject: ({ projectId }) => dispatch(showProject({ projectId })),
    changeKeyword: ({ keyword }) => dispatch(changeKeyword(keyword)),
    doSearchTask: (searchStr) => dispatch(searchTask(searchStr)),
    doActionVisibleDrawerMessage: (option) =>
      dispatch(actionVisibleDrawerMessage(option)),
    doSetVisibleHeader: (visible) => dispatch(setVisibleHeader(visible)),
    doListTask: ({ projectId, timeStart, timeEnd }, quite) =>
      dispatch(listTask({ projectId, timeStart, timeEnd }, quite)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutDetail);
